/**
 * Indicates a Dynamic Media / Scene7 delivered image: an absolute URL (http(s):// or
 * protocol-relative //), or one bearing the Scene7 image-serving marker (`/is/image/`).
 * Relative AEM-rendered paths (e.g. /content/dam/...) are not DM-delivered and return false.
 */
export const isDynamicMediaUrl = (url) =>
    /^(https?:)?\/\//i.test(url) || /\/is\/image\//i.test(url);

/**
 * Appends the authored Dynamic Media image preset to a result image URL using the Scene7
 * named-preset modifier syntax (`?$presetName$`, or `&$presetName$` when the URL already
 * carries query params). Only applied when a preset is authored and the URL is a DM/Scene7
 * image; otherwise the URL is returned unchanged.
 */
export const appendImagePreset = (url, imagePreset) => {
    if (!url || !imagePreset || !isDynamicMediaUrl(url)) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}$${imagePreset}$`;
};

/**
 * Appends raw Dynamic Media query parameters (e.g. `wid=280&hei=157`) to a DM image URL.
 * Unlike appendImagePreset, no `$...$` Scene7 named-preset wrapping is applied.
 */
export const appendDmParameters = (url, params) => {
    if (!url || !params || !isDynamicMediaUrl(url)) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${params}`;
};
